export const ru = {
    'banner-id': '№ {id}',
    'show-preview': 'Показать креатив'
};
